import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Settings, Cpu, FolderKanban, BookText, GitBranch, Inbox, ClipboardList } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

const SECTIONS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/admin/site", label: "Site Config", icon: Settings },
  { to: "/admin/skills", label: "Skills", icon: Cpu },
  { to: "/admin/projects", label: "Projects", icon: FolderKanban },
  { to: "/admin/blog", label: "Blog Posts", icon: BookText },
  { to: "/admin/timeline", label: "Career Timeline", icon: GitBranch },
  { to: "/admin/messages", label: "Messages", icon: Inbox },
  { to: "/admin/surveys", label: "Surveys", icon: ClipboardList },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-[260px_1fr] bg-background text-foreground">
      <aside className="border-r border-border bg-secondary/40">
        <div className="p-5 border-b border-border">
          <p className="label-xs">Portfolio CMS</p>
          <p className="mt-1 font-heading font-bold text-lg tracking-tight">Admin</p>
        </div>
        <nav className="p-3 space-y-1">
          {SECTIONS.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              end={s.exact}
              data-testid={`admin-nav-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 text-sm rounded-sm transition-colors ${
                  isActive
                    ? "bg-foreground text-background"
                    : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`
              }
            >
              <s.icon className="h-4 w-4" />
              {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-border mt-6">
          <p className="text-xs text-muted-foreground">Signed in as</p>
          <p className="text-sm truncate">{user?.email}</p>
          <button
            onClick={() => {
              logout();
              navigate("/admin/login");
            }}
            className="mt-3 inline-flex items-center gap-2 text-xs px-3 py-1.5 border border-border rounded-sm hover:bg-foreground hover:text-background transition-colors"
            data-testid="admin-logout"
          >
            <LogOut className="h-3.5 w-3.5" /> Sign out
          </button>
        </div>
      </aside>

      <main className="p-6 lg:p-10 overflow-x-hidden">
        <Outlet />
      </main>
      <Toaster />
    </div>
  );
}
